import PropTypes from "prop-types"

// @mui material components
import Icon from "@mui/material/Icon"
import { Grid, Tooltip } from "@mui/material"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

// Context
import { useMaterialUIController } from "context"

// React Router
import { useNavigate } from "react-router-dom"

// Services
import { deleteOrganizacion } from "layouts/asistencia/dependencias/components/add/service"

function OrganizacionItem({
  id,
  nombre,
  sucursal,
  parentNombre,
  noGutter,
  onReload,
}) {
  const [controller] = useMaterialUIController()
  const { darkMode } = controller
  const navigate = useNavigate()

  const handleEdit = (idOrganizacion) => {
    navigate(`/asistencia/dependencias/${idOrganizacion}`)
  }

  const handleDelete = async (idOrganizacion) => {
    try {
      const deleted = await deleteOrganizacion(idOrganizacion)
      if (deleted) {
        onReload()
      }
    } catch (error) {
      console.error("Error deleting dependencia:", error)
    }
  }

  return (
    <MDBox
      id={id}
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
          mb={2}
        >
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                {nombre}
              </MDTypography>
            </Grid>
            <Grid item xs={12} md={12}>
              <MDTypography variant="caption" fontWeight="light">
                SUCURSAL: {sucursal}
              </MDTypography>
            </Grid>
          </Grid>
          <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDBox mr={1}>
              <Tooltip title="Eliminar dependencia">
                <MDButton variant="text" color="error" onClick={() => handleDelete(id)}>
                  <Icon>delete</Icon>&nbsp;Eliminar
                </MDButton>
              </Tooltip>
            </MDBox>
            <Tooltip title="Editar dependencia">
              <MDButton
                data-id={id}
                variant="text"
                color={darkMode ? "white" : "dark"}
                onClick={() => handleEdit(id)}
              >
                <Icon>edit</Icon>&nbsp;Editar
              </MDButton>
            </Tooltip>
          </MDBox>
        </MDBox>
        {parentNombre && (
          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" color="text">
              Dependencia Padre:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium" textTransform="capitalize">
                {parentNombre}
              </MDTypography>
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  )
}

// Default values
OrganizacionItem.defaultProps = {
  noGutter: false,
  onReload: () => {},
  parentNombre: null,
}

// PropTypes
OrganizacionItem.propTypes = {
  id: PropTypes.number.isRequired,
  nombre: PropTypes.string.isRequired,
  sucursal: PropTypes.string.isRequired,
  parentNombre: PropTypes.string,
  noGutter: PropTypes.bool,
  onReload: PropTypes.func,
}

export default OrganizacionItem
